const ls = window.localStorage;

export function getItem(key: string): string {
  return ls.getItem(key);
}

export function setItem(key: string, value: string) {
  return ls.setItem(key, value);
}

export function removeItem(key: string) {
  return ls.removeItem(key);
}

export default ls;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/storage_wrapper.ts